export enum Themes {
  dark = 'dark-theme',
  light = 'light-theme',
}
